/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { AlertingHookDto } from './AlertingHookDto';
import type { DatasetLightDto } from './DatasetLightDto';
import type { EntityCustomMetadataDto } from './EntityCustomMetadataDto';
import type { FieldSearchResultDto } from './FieldSearchResultDto';
import type { JoinParamsDto } from './JoinParamsDto';
import type { LegacyJiraIssueSettings } from './LegacyJiraIssueSettings';
import type { ServiceNowIncidentSettings } from './ServiceNowIncidentSettings';
import type { StronglyTypedRuleInputParams } from './StronglyTypedRuleInputParams';
import type { TagDto } from './TagDto';
import type { TimeZoneDto } from './TimeZoneDto';

export type RuleDto = {
    category?: string;
    createIncidentOnFail: boolean;
    readonly creationMethod?: RuleDto.creationMethod;
    credentialSecretName?: string;
    criticality: number;
    customEmailSubject?: string;
    customMetadata?: Array<EntityCustomMetadataDto>;
    datasets: Array<DatasetLightDto>;
    description?: string;
    friendlyId?: string;
    id?: string;
    inputValues?: StronglyTypedRuleInputParams;
    isOverridingNotificationRules?: boolean;
    jiraIssueSettings?: LegacyJiraIssueSettings;
    joinParams?: JoinParamsDto;
    mails?: Array<AlertingHookDto>;
    message?: string;
    monitoredDatasetFields: Array<FieldSearchResultDto>;
    msTeams?: Array<AlertingHookDto>;
    name: string;
    ruleTemplateName?: string;
    schedule?: string;
    scheduleTimezone?: TimeZoneDto;
    serviceNowIncidentSettings?: ServiceNowIncidentSettings;
    slackChannels?: Array<AlertingHookDto>;
    tags?: Array<TagDto>;
    terms?: Array<TagDto>;
    webhooks?: Array<AlertingHookDto>;
};

export namespace RuleDto {

    export enum creationMethod {
        DBT_INGESTION = 'DBT_INGESTION',
        UI = 'UI',
        AUTO_COVERAGE = 'AUTO_COVERAGE',
        AS_CODE = 'AS_CODE',
        METADATA_MONITORING = 'METADATA_MONITORING',
        RECOMMENDATION = 'RECOMMENDATION',
        API = 'API',
    }


}
